export default "__VITE_ASSET__DHUEN$8d__"